module.exports = __webpack_public_path__ + "img/bj.5a07ee7f.svg";